import React from "react";
import { useTranslation } from "react-i18next";

import { FlagIcon, WarningIcon } from "fe-shared/src/components/Icons";
import { FLAG_COLOR } from "fe-shared-requests/src/consts";

import { PickupRequestListItem } from "types";

import styles from "./WarningGridCell.module.scss";

interface Props {
  data: PickupRequestListItem;
}

const WarningGridCell = ({ data }: Props) => {
  const { t } = useTranslation();

  // The flag is not folded into the warning tooltip: it is raised by a person, the others are
  // derived from missing data, and the row has to tell them apart at a glance.
  const warnings = [
    !data.targetCompanyName && t("pickupRequests.grid.warnings.noHauler"),
    !data.carrierFirstName &&
      t("pickupRequests.grid.warnings.carrierNotAssigned"),
  ].filter(Boolean) as string[];

  if (!warnings.length && !data.isFlagged) {
    return null;
  }

  return (
    <span className={styles.warnings}>
      {!!warnings.length && (
        <span title={warnings.join(", ")}>
          <WarningIcon />
        </span>
      )}
      {data.isFlagged && (
        <span title={t("pickupRequests.grid.warnings.flagged")}>
          <FlagIcon fillColor={FLAG_COLOR} />
        </span>
      )}
    </span>
  );
};

export default WarningGridCell;
